var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7297 0H1.5426C0.800885 0 0.198242 0.611072 0.198242 1.36121V17.5188C0.198242 18.2689 0.800885 18.88 1.5426 18.88H17.7297C18.4714 18.88 19.0782 18.2689 19.0782 17.5188V1.36121C19.0782 0.611072 18.4714 0 17.7297 0ZM5.90438 16.1829H3.1061V7.17271H5.9086V16.1829H5.90438ZM4.50524 5.94214C3.6076 5.94214 2.88274 5.21307 2.88274 4.31964C2.88274 3.42621 3.6076 2.69714 4.50524 2.69714C5.39867 2.69714 6.12774 3.42621 6.12774 4.31964C6.12774 5.21729 5.40288 5.94214 4.50524 5.94214ZM16.3937 16.1829H13.5955V11.8C13.5955 10.7549 13.5744 9.4105 12.1415 9.4105C10.6834 9.4105 10.46 10.5484 10.46 11.7241V16.1829H7.66174V7.17271H10.3462V8.40329H10.3842C10.7592 7.69529 11.6737 6.94936 13.035 6.94936C15.867 6.94936 16.3937 8.81629 16.3937 11.2437V16.1829Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/ln.afa990f2740b632471765a35b60af7e6.svg";
export { ForwardRef as ReactComponent };